import { useEffect } from 'react';
import { createPath } from 'quartz-routing/react-router';
import { useACNavigate } from '../hooks/useACNavigate';
import { useEffectEvent } from '../hooks/useEffectEvent';
export const ACRedirect = ({
  to,
  push
}) => {
  const navigate = useACNavigate();
  const path = typeof to === 'string' ? to : createPath(to);
  const onRedirect = useEffectEvent(() => {
    navigate(to, {
      replace: !push
    });
  });
  useEffect(() => {
    onRedirect();
  }, [path]);
  return null;
};